/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
/* eslint-disable */
const levenshtein = require('js-levenshtein');

const cardAdd = () => {
  if (
    document.querySelector('body').classList.contains('js-user-has-company')
  ) {
    let userStatus = document.querySelector('body').dataset.companyStatus;
    if (userStatus === '') {
      userStatus = 'waiting';
    }
    const statuses = {
      ok: 'zaakceptowana',
      waiting: 'w weryfikacji',
      no: 'odrzucona',
    };
    const myTradeMenu = document.querySelectorAll(
      '.c-quick-link-section .c-link-box__title',
    );
    myTradeMenu.forEach(el => {
      if (el.innerHTML == 'Dodaj wizytówkę swojej firmy') {
        el.innerHTML = `Edytuj wizytówkę swojej firmy <span class="avalibility-message is-${userStatus}">Status: ${statuses[userStatus]
          }</span>`;
      }
    });
  }
  const form = document.querySelector('.js-card-add');
  document.querySelectorAll('[required]').forEach(element => {
    element.addEventListener('keyup', e => {
      if (e.target.checkValidity()) {
        e.target.closest('.c-label').classList.remove('has-error');
      } else {
        e.target.closest('.c-label').classList.add('has-error');
      }
    });
  });
  if (form) {
    const changeActiveCard = (nextCard,go) => {
      const urlParams = new URLSearchParams(window.location.search);
      const mode = urlParams.get('ks_edit');


      if ((!mode && nextCard === 3) || (mode && nextCard === 2)) {   
        const nipInput = document.querySelector('input[name="company-nip"]');
        if (validateNIP(nipInput) === false) {
          return;
        }
        getgusapi()
      }   
      if ((!mode && nextCard === 4) || (mode && nextCard === 3)) {      
        const voivodeshipsInput = document.querySelector('input[name="company-voivodeships"]');  
        if (validateVoivodeships(voivodeshipsInput) === false) {
          return;
        }
      }
      if ((!mode && nextCard === 5) || (mode && nextCard === 4)) {
        if (validateDuplicatesInTextareas() === false) {
          return;
        }

        const industriesInput = document.querySelector('input[name="company-industries"]');
        const countriesInput = document.querySelector('input[name="company-countries-wannabe"]');
        const industries = validateContriesAndIndustries(industriesInput);
        const countries = validateContriesAndIndustries(countriesInput);

        if (!industries || !countries) {
          const target = !!industries === false ? industriesInput : countriesInput;
          target.closest('.js-filter-top').scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
      }
      if(!go){
        return;
      }

      if ((!mode && nextCard === 6) || (mode && nextCard === 5)) {
        const formInputs = form.querySelectorAll('input, textarea');
        formInputs.forEach(input => {
          const name = input.getAttribute('name');
          const foundedInput = form.querySelector(
            `.js-input-content[data-field="${name}"]`,
          );
          if (name.substring(0, 19) === 'company-offer-image' &&
            foundedInput
          ) {
            if (document.querySelector(`input[name="check-${name}"`) && document.querySelector(`input[name="check-${name}"`).value === "1") {
              foundedInput.innerHTML = `<div class="c-file__file u-flex-1/2">
                <img decoding="async" class="c-file__image no-lazyload" src="${document.querySelector(`input[name="check-${name}"`).parentElement.parentElement.querySelector('.js-image-preview').dataset.src}" alt="">
                <p class="c-file__name"></p>
              </div>
              <p class="c-file__description u-flex-1/2 js-input-content" data-field="company-offer-image-1-desc"></p>`;
              foundedInput.classList.remove('u-hidden');
            }
          }
          if (
            (name.substring(16, 20) === 'desc' ||
              name.substring(15, 19) === 'desc') &&
            foundedInput
          ) {
            foundedInput.innerHTML = input.value;
            foundedInput.classList.remove('u-hidden');
          }
        });
      }
      if ((!mode && nextCard === 7) || (mode && nextCard === 6)) {
        const formInputs = form.querySelectorAll('input, textarea');
        formInputs.forEach(input => {
          const name = input.getAttribute('name');
          const foundedInput = form.querySelector(
            `.js-input-content[data-field="${name}"]`,
          );
          if (
            (name.substring(16, 20) === 'desc' ||
              name.substring(15, 19) === 'desc') &&
            foundedInput
          ) {
            foundedInput.innerHTML = input.value;
            foundedInput.classList.remove('u-hidden');
          }
          if (name.substring(0, 13) === 'company-image' &&
            foundedInput
          ) {
            if (document.querySelector(`input[name="check-${name}"`) && document.querySelector(`input[name="check-${name}"`).value === "1") {
              foundedInput.innerHTML = `<div class="c-file__file u-flex-1/2">
                <img decoding="async" class="c-file__image no-lazyload" src="${document.querySelector(`input[name="check-${name}"`).parentElement.parentElement.querySelector('.js-image-preview').dataset.src}" alt="">
                <p class="c-file__name"></p>
              </div>
              <p class="c-file__description u-flex-1/2 js-input-content" data-field="company-image-1-desc"></p>`;
              foundedInput.classList.remove('u-hidden');
            }
          }
          if (name.substring(0, 12) === 'company-file' &&
            foundedInput
          ) {
            if (document.querySelector(`input[name="check-${name}"`) && document.querySelector(`input[name="check-${name}"`).value === "1") {
              foundedInput.innerHTML = `
              <span class="c-file__icon o-media__svg"><svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M14.59 2.59c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM15 18H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm-2-6V3.5L18.5 9H14c-.55 0-1-.45-1-1z"></path></svg></span>
              <div class="c-file__data">
                <p class="c-file__name">${document.querySelector(`input[name="check-${name}"`).parentElement.parentElement.querySelector('.js-image-preview .c-file__name a').text}</p>
                          </div>`;
              foundedInput.classList.remove('u-hidden');
            }
          }
        });
      }
      const cards = document.querySelectorAll('.js-card-part');
      cards.forEach(element => {
        element.classList.remove('is-active');
      });
      form
        .querySelector(`.js-card-part[data-step="${nextCard}"]`)
        .classList.add('is-active');
    };
    const moveCard = direction => {
      const activeCardElem = form.querySelector('.js-card-part.is-active');
      const activeCard = activeCardElem.dataset.step;
      let go = true;
      activeCardElem.querySelectorAll('input,textarea').forEach(element => {
        if (!element.checkValidity()) {
          go = false;
          element.parentElement.parentElement.classList.add('has-error');
        }
      });
      let nextCard = activeCard;
      if (direction > 0) {
        nextCard++;
        changeActiveCard(nextCard,go);
      } else if (direction < 0) {
        nextCard--;
        changeActiveCard(nextCard,go);
      }
      window.scrollTo({
        top: document.querySelector('.c-header').clientHeight,
        left: 0,
        behavior: 'smooth',
      });
    };

    const nipInput = document.querySelector('input[name="company-nip"]');
    if (nipInput) {
      nipInput.addEventListener('keydown', e => {
        const codes = [69, 188, 189, 190];
        if (codes.includes(e.keyCode)) {
          e.preventDefault();
        }
      });
      nipInput.addEventListener('input', e => {
        validateNIP(e.target);
      });
      nipInput.addEventListener('paste', e => {
        e.preventDefault();
        let pastedText = '';

        if (e.clipboardData && e.clipboardData.getData) {
          // Standards Compliant FIRST!
          pastedText = e.clipboardData.getData('text/plain');
        } else if (window.clipboardData && window.clipboardData.getData) {
          // IE
          pastedText = window.clipboardData.getData('Text');
        }

        e.target.value = pastedText.replaceAll('-', '');
        validateNIP(e.target);
      });
    }
    const getgusapi = e => {
      console.log(e); 
      if(typeof e !== 'undefined'){
        e.preventDefault();
      }
      let formType = document.querySelector('form input[type="hidden"][name="action"]').value;
      if (formType === 'edit_company') {
        return true;
      }
      if (!validateNIP(nipInput)) return;

      nipInput.closest('label').classList.remove('has-error');

      const nip = document.querySelector('input[name="company-nip"]').value;
      const dataNip = {
        action: 'get_nip_data',
        nip,
      };
      const urlParameters = Object.entries(dataNip)
        .map(arr => arr.join('='))
        .join('&');

      const request = new XMLHttpRequest();
      request.open('POST', `/wp-admin/admin-ajax.php`, true);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );

      request.onload = () => {
        if (request.response === 'false') {
          document
            .querySelector('input[name="company-nip"]')
            .parentElement.parentElement.classList.add('has-error');
        }

        if (request.response) {
          const data = JSON.parse(request.response);
          if (data) {
            if (data.name) {
              document.querySelector('input[name="company-name"]').value =
                data.name;
              document
                .querySelector('input[name="company-name"]')
                .dispatchEvent(new CustomEvent('change'));
              document.querySelector(
                'input[name="company-address"]',
              ).value = `${data.street} ${data.propertyNumber}${data.apartmentNumber ? `/${data.apartmentNumber}` : ''
              }`;
              document
                .querySelector('input[name="company-address"]')
                .dispatchEvent(new CustomEvent('change'));
              document.querySelector('input[name="company-postal"]').value =
                data.zipCode;
              document
                .querySelector('input[name="company-postal"]')
                .dispatchEvent(new CustomEvent('change'));
              document.querySelector('input[name="company-town"]').value =
                data.postCity;
              document
                .querySelector('input[name="company-town"]')
                .dispatchEvent(new CustomEvent('change'));
              moveCard(1);
            } else {
              document.querySelectorAll('.js-card-part').forEach(item => {
                item.classList.add('is-hidden');
                item.classList.remove('is-active');
              });
              document.querySelector(
                '.js-card-end-input[data-field="company-nip"]',
              ).innerHTML = data.company.nip;
              document.querySelector(
                '.js-card-end-input[data-field="company-name"]',
              ).innerHTML = data.company.name;
              document.querySelector(
                '.js-card-end-input[data-field="company-address"]',
              ).innerHTML = data.company.address;
              document.querySelector(
                '.js-card-end-input[data-field="company-postal"]',
              ).innerHTML = data.company.postal;
              document.querySelector(
                '.js-card-end-input[data-field="company-town"]',
              ).innerHTML = data.company.town;
              document.querySelector(
                '.js-card-end-input[data-field="company-phone"]',
              ).innerHTML = data.company.phone;
              document.querySelector(
                '.js-card-end-input[data-field="company-website"]',
              ).innerHTML = data.company.website;
              document.querySelector(
                '.js-card-end-input[data-field="company-email"]',
              ).innerHTML = data.company.email;
              document
                .querySelector('.js-card-part[data-step="end"]')
                .classList.remove('is-hidden');
              document
                .querySelector('.js-card-part[data-step="end"]')
                .classList.add('is-active');
            }
          }
        }
      };
      request.onerror = () => {
        alert('Problem z serwerem Gus');
      };
      request.send(urlParameters);
      return true;
    };

    const gusBtn = document.querySelector('.js-gus-api');
    if (gusBtn) {
      gusBtn.addEventListener('click', getgusapi);
    }

    const cardNavigationButtons = document.querySelectorAll('.js-navigation');
    cardNavigationButtons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        moveCard(e.target.dataset.direction);
      });
    });

    window.formJson = [];
    const prepareFormJson = inputs => {
      inputs.forEach(input => {
        const name = input.getAttribute('name');
        if (
          name === 'company-logo' ||
          name.substring(0, 13) === 'company-image'
        ) {
          const file = input.files[0];
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener(
              'load',
              () => {
                window.formJson[name] = reader.result;
              },
              false,
            );
          } else {
            if (document.querySelector(`input[name="check-${name}"`) && document.querySelector(`input[name="check-${name}"`).value === "1") {
              window.formJson[name] = document.querySelector(`input[name="check-${name}"`).parentElement.parentElement.querySelector('.js-image-preview').dataset.src;
            } else {
              window.formJson[name] = '';
            }
          }
        } else if (name.substring(0, 12) === 'company-file') {
          const file = input.files[0];
          if (file) {
            window.formJson[name] = file.name;
          } else {
            if (document.querySelector(`input[name="check-${name}"`) && document.querySelector(`input[name="check-${name}"`).value === "1") {
              window.formJson[name] = document.querySelector(`input[name="check-${name}"`).parentElement.parentElement.querySelector('.js-image-preview .c-file__name a').text;
            } else {
              window.formJson[name] = '';
            }
          }
        }else if (name.substring(0, 19) === 'company-offer-image') {
          const file = input.files[0];
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener(
              'load',
              () => {
                window.formJson[name] = reader.result;
              },
              false,
            );
          } else {
            if (document.querySelector(`input[name="check-${name}"`) && document.querySelector(`input[name="check-${name}"`).value === "1") {
              window.formJson[name] = document.querySelector(`input[name="check-${name}"`).parentElement.parentElement.querySelector('.js-image-preview').dataset.src;
            } else {
              window.formJson[name] = '';
            }
          }
        } else {
          window.formJson[name] = input.value;
        }
      });
    };

    const formInputs = form.querySelectorAll('input, textarea');
    function actionOnInputChange(form,formInputs,e){
      prepareFormJson(formInputs);
      const name = e.target.getAttribute('name');
      const foundedInput = form.querySelector(
        `.js-input-content[data-field="${name}"]`,
      );
      const imagesHeader = form.querySelector('.js-images-header');
      if (
        name === 'company-industries' ||
        name === 'company-countries' ||
        // name === 'company-languages'
        name === 'company-voivodeships'
      ) {
        const values = e.target.value.toString().split(',');
        let ret = '';
        values.forEach(id => {
          if (ret !== '') {
            ret += ', ';
          }
          const checkbox = document.querySelector(
            `input[type="checkbox"][value="${id}"]`,
          );
          let parent = null;
          if (checkbox) {
            parent = checkbox.parentElement;
            if (parent.querySelector('.c-label__title')) {
              ret += parent.querySelector('.c-label__title').innerHTML;
            } else {
              ret += parent.parentElement.querySelector('.c-label__title')
                .innerHTML;
            }
          }
        });
        if(foundedInput){
          foundedInput.innerHTML = ret;
        }
      } else if (
        name === 'company-logo' ||
        name.substring(0, 13) === 'company-image'
      ) {
        const file = e.target.files[0];
        if (file) {
          foundedInput.querySelector('.c-file__name').innerHTML = file.name;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.addEventListener(
            'load',
            () => {
              foundedInput.querySelector('.c-file__image').src =
                reader.result;
            },
            false,
          );
          imagesHeader.classList.remove('u-hidden');
        } else {
          foundedInput.querySelector('.c-file__name').innerHTML = '';
          foundedInput.querySelector('.c-file__image').src = '';
          imagesHeader.classList.add('u-hidden');
        }
      } else if (
          name.substring(0, 19) === 'company-offer-image'
        ) {
          const file = e.target.files[0];
          if (file) {
            foundedInput.querySelector('.c-file__name').innerHTML = file.name;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener(
              'load',
              () => {
                foundedInput.querySelector('.c-file__image').src =
                  reader.result;
              },
              false,
            );
            imagesHeader.classList.remove('u-hidden');
          } else {
            foundedInput.querySelector('.c-file__name').innerHTML = '';
            foundedInput.querySelector('.c-file__image').src = '';
            imagesHeader.classList.add('u-hidden');
          }
      } else if (name.substring(0, 12) === 'company-file') {
        const file = e.target.files[0];
        if (file) {
          foundedInput.querySelector('.c-file__name').innerHTML = file.name;
        }
        imagesHeader.classList.remove('u-hidden');
      } else if (foundedInput) {
        if (e.target.type == 'textarea') {
          foundedInput.innerHTML = (e.target.value + '').replace(
            /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
            '$1' + '<br>' + '$2',
          );
        } else {
          foundedInput.innerHTML = e.target.value;
        }
      }

      if (
        (e.target.value || (e.target.files && e.target.files.length)) &&
        foundedInput
      ) {
        foundedInput.classList.remove('u-hidden');
        if (
          foundedInput.previousElementSibling &&
          !foundedInput.previousElementSibling.classList.contains('c-file')
        ) {
          foundedInput.previousElementSibling.classList.remove('u-hidden');
        }
      }

    }
    formInputs.forEach(input => {
      input.addEventListener('change', e => {
        actionOnInputChange(form,formInputs,e);
      });
      input.addEventListener('paste', e => {
        actionOnInputChange(form,formInputs,e);
      });
      const evt = new CustomEvent('change');
      input.dispatchEvent(evt);
    });

    const previewForm = document.querySelector('.js-preview-form');
    if (previewForm) {
      previewForm.addEventListener('click', e => {
        const obj = window.formJson;
        obj.action = 'preshow_company';
        if (!!previewForm.dataset.companyId) {
          obj.company_id = previewForm.dataset.companyId;
        }
        const urlParameters = Object.entries(obj)
          .map(arr => arr.join('='))
          .join('&');

        const request = new XMLHttpRequest();
        request.open('POST', `/wp-admin/admin-ajax.php`, true);
        request.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded;',
        );

        request.onload = () => {
          if (request.response) {
            document.querySelector('.js-pc-content').innerHTML =
              request.response;
            const links = document.querySelectorAll('.js-pc-content a');
            links.forEach(element => {
              element.removeAttribute('href');
            });
          }
        };
        request.send(urlParameters);
      });
    }

    const formManipulation = (e, mode) => {
      e.preventDefault();
      e.target.classList.add('is-loading');
      const formData = new FormData(form);
      fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
      })
        .then(response => response.json())
        .then(response => {
          if (response.success && response.data.direction) {
            moveCard(response.data.direction);
          }
        })
        .catch(error => {
          console.error(error);
        });
    };

    const saveForm = document.querySelector('.js-save-form');
    if (saveForm) {
      saveForm.addEventListener('click', e => {
        formManipulation(e, 'save');
      });
    }
    const editForm = document.querySelector('.js-edit-form');
    if (editForm) {
      editForm.addEventListener('click', e => {
        formManipulation(e, 'edit');
      });
    }
  }
  window.validateFormInput = obj => {
    if (obj.parentElement.parentElement) {
      if (!obj.checkValidity()) {
        obj.parentElement.parentElement.classList.add('has-error');
      } else {
        obj.parentElement.parentElement.classList.remove('has-error');
      }
    }
  };

  const validateNIP = input => {
    const re = /^[\d]{10}$/;
    if (!re.test(input.value.toLowerCase())) {
      input.closest('label').classList.add('has-error');
      return false;
    } else {
      input.closest('label').classList.remove('has-error');
      return true;
    }
  };

  const validateVoivodeships = input => {
    if (input.value == "" || input.value == "0") {
      input.parentNode.classList.add('has-error');
      input.parentNode.querySelector('.js-check-error').classList.add('has-error');
      return false;
    } else {
      input.parentNode.classList.remove('has-error');
      input.parentNode.querySelector('.js-check-error').classList.remove('has-error');
      return true;
    }
  }

  const validateContriesAndIndustries = input => {
    if (input.value == "" || input.value == "0") {
      input.parentNode.classList.add('has-error');
      input.parentNode.querySelector('.js-check-error').classList.add('has-error');
      return false;
    } else {
      input.parentNode.classList.add('has-error');
      input.parentNode.querySelector('.js-check-error').classList.remove('has-error');
      return true;
    }
  }

  // compare textareas with levensthain distance algorithm
  const validateDuplicatesInTextareas = () => {
    const desc = document.querySelector('textarea[name="company-desc"]');
    const offer = document.querySelector('textarea[name="company-offer"]');
    const leven = levenshtein(offer.value, desc.value);
    const percentage = (leven / Math.max(offer.value.length, desc.value.length)) * 100;
    if (percentage < 25) {
      desc.classList.add('has-duplicate');
      offer.classList.add('has-duplicate');
      document.querySelector('.js-duplicates-error').classList.remove('u-hidden')
      document.querySelector('.js-duplicates-error').scrollIntoView({ behavior: "smooth", block: "start" });
      return false;
    } else {
      desc.classList.remove('has-duplicate');
      offer.classList.remove('has-duplicate');
      document.querySelector('.js-duplicates-error').classList.add('u-hidden');
      return true;
    }
  }
};

export default cardAdd;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/cardAdd.js